import React from "react";
import { resolveCatalogPillParts } from "tap/utils/parseCatalogTitleWithId.js";

const ellipsisStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
};

/**
 * Renders pill text with optional truncation; catalogs keep trailing (id) visible.
 * @param {Object} props
 * @param {string} props.label - Full display label
 * @param {Object} [props.item] - Catalog row object (name/id preferred over titleWithId)
 * @param {boolean} [props.preserveTrailingId] - Split titleWithId and keep id suffix
 * @param {boolean} [props.truncate] - When false, show full label without ellipsis
 */
export function PillboxLabelContent({
  label,
  item,
  preserveTrailingId = false,
  truncate = true,
}) {
  const text = String(label ?? "");

  if (!truncate) {
    return <span>{text}</span>;
  }

  const parsed = preserveTrailingId
    ? resolveCatalogPillParts(item ?? text)
    : null;

  if (parsed) {
    const tooltip = `${parsed.title} (${parsed.id})`;
    return (
      <span
        title={tooltip}
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) auto",
          columnGap: "0.25em",
          minWidth: 0,
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        <span style={ellipsisStyle}>{parsed.title}</span>
        <span style={{ whiteSpace: "nowrap" }}>({parsed.id})</span>
      </span>
    );
  }

  return (
    <span title={text} style={{ ...ellipsisStyle, display: "block", maxWidth: "100%" }}>
      {text}
    </span>
  );
}
